export type PartyRole = "customer" | "supplier" | "investor";
export type PartyKind = "all" | PartyRole;

export const PARTY_TYPE_LABELS: Record<PartyKind, string> = {
  all: "All",
  customer: "Customer",
  supplier: "Supplier",
  investor: "Investor",
};

export function partyTypeOptionsForRole(role: PartyRole): { value: PartyKind; label: string }[] {
  return [
    { value: "all", label: PARTY_TYPE_LABELS.all },
    { value: role, label: PARTY_TYPE_LABELS[role] },
  ];
}

export function normalizePartyType(raw: string | null | undefined, fallback: PartyRole): PartyKind {
  const key = (raw ?? "")
    .replace(/([a-z])([A-Z])/g, "$1-$2")
    .replace(/[\s_]+/g, "-")
    .trim()
    .toLowerCase();
  if (key === "all" || key === "both") return "all";
  if (key === fallback) return fallback;
  return fallback;
}

export function partyTypeLabel(type: string | null | undefined, fallback: PartyRole): string {
  const n = normalizePartyType(type, fallback);
  return PARTY_TYPE_LABELS[n];
}
